import feathers from '@feathersjs/client';
import { ContextCacheMap } from 'feathers-fletching';
import { cache, stashCache } from 'src/feathers/hooks';
import { scriptLoader } from 'straightline-ui';
import { parsePlace } from 'straightline-utils/validation';
const { GeneralError } = feathers.errors;

class Service {
  constructor(options) {
    this.options = options || {};
    this.geocoder = null;
  }

  async find(params) {
    if (!this.geocoder) {
      await scriptLoader.load(process.env.REACT_APP_GOOGLE_MAPS_URL);
      this.geocoder = new window.google.maps.Geocoder();
    }

    const result = await new Promise((resolve, reject) => {
      this.geocoder.geocode(params.query, (response, status) => {
        if (status !== 'OK') {
          // If you end up here looking for why this error is throwing
          // in Sentry or elsewhere, its likely the ZERO_RESULTS status.
          // Which is fine...I think that is expected behavior and no
          // need to capture any more info.
          // See also: https://developers.google.com/maps/documentation/javascript/reference/geocoder#GeocoderRequest.fulfillOnZeroResults
          reject(
            new GeneralError(
              'There was an error from Google geocoding the location.',
              { status }
            )
          );
        } else {
          resolve(response);
        }
      });
    });

    if (result[0]) {
      return parsePlace(result[0]);
    }

    return null;
  }
}

export default (app) => {
  const options = {
    cacheMap: new ContextCacheMap({
      max: 50
    })
  };

  app.use('google/geocode', new Service(options));
  const service = app.service('google/geocode');

  service.hooks({
    before: {
      all: [],
      find: [cache]
    },

    after: {
      all: [],
      find: [cache, stashCache()]
    }
  });
};
